import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { NeedType, PrimaryCategories, ProviderToUseResponse, UserInfo , screeningCheck} from './api.types';
import { TMemberInfo } from '@repo/utils';

export type NoMemberInContext = null;
export type NoAdvocateInContext = null;
export type NoIdentifiedNeedsInContext = null;
export type NoScreeningInContext = null;

// The user info of the advocate who is currently signed into the app.
export const loggedInAdvocateAtom = atomWithStorage<
  UserInfo | NoAdvocateInContext
>(
  'UHC-CC-AGENT-DETAILS',
  null as NoAdvocateInContext,
  createJSONStorage<UserInfo | NoAdvocateInContext>(() => sessionStorage)
);

export const checkDisableScreeningAtom = atomWithStorage<
screeningCheck | NoScreeningInContext
>
(
    'UHC-CC-Screening',
     null as NoScreeningInContext,
     createJSONStorage<screeningCheck | NoScreeningInContext>(()=> sessionStorage)
);

//   );
// The info for the member that the advocate is currently assisting.
// This will be set after the advocate selects a member from the "member search" form.

export const memberInContextAtom = atomWithStorage<
  TMemberInfo | NoMemberInContext
>(
  'UHC-CC-MEMBER-DETAILS',
  null as NoMemberInContext,
  createJSONStorage<TMemberInfo | NoMemberInContext>(() => sessionStorage)
);

export const identifiedNeedsAtom = atomWithStorage<
  NeedType[] | NoIdentifiedNeedsInContext
>(
  'Identified-Needs',
  null as NoIdentifiedNeedsInContext,
  createJSONStorage<NeedType[] | NoIdentifiedNeedsInContext>(() => sessionStorage)
);

export const primaryCategoriesAtom = atomWithStorage<PrimaryCategories | null>(
  'Primary-Categories',
  null,
  createJSONStorage<PrimaryCategories>(() => sessionStorage)
);

// Cached result of API.fetchProviderToUse, keyed by the zipcode that was last fetched.
// Stored in sessionStorage so it survives page navigations within the same session.
export const vendorAtom = atomWithStorage<{
  zipcode: string;
  response: ProviderToUseResponse;
} | null>(
  'UHC-CC-VENDOR-CACHE',
  null,
  createJSONStorage<{ zipcode: string; response: ProviderToUseResponse } | null>(
    () => sessionStorage
  )
);

export type MemberInContext = {
  dob: {
    month: number;
    day: number;
    year: number;
  };
  eId: string | null;
  emailAddress: string | null;
  firstName: string;
  lastName: string;

  // This looks scary but I promise it's not, using Omit here gives us
  //  autocomplete over the union members while still allowing all other strings as valid.
  // See https://www.youtube.com/watch?v=a_m7jxrTlaw&list=PLIvujZeVDLMx040-j1W4WFs1BxuTGdI_b&index=3
  lineOfBusiness:
    | 'E&I'
    | 'C&S'
    | 'M&R'
    | 'IFP'
    | Omit<string, 'E&I' | 'C&S' | 'M&R' | 'IFP'>;
  memberId: string;
  memberType: string;
  phoneNumber: string | null;
  zipCode: string | null;
  state?: string | null;
  member_id?: string | null;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  referenceId: string | null;
};
